import { JUDGE_IS_LOGIN } from '@store/officialStore/login';
import { CHECK_IP_LOCATION } from '@store/ipCheck';
import {
  jumpPnsWithToken,
  NEED_TO_JUMP_PNS_GAMEID
} from '@utiles/jumpWithToken';
import { mapState } from 'vuex';
import {
  GET_SEPC_GAME_INFO,
  GET_LASTED_STORE_ROLE
} from '@store/officialStore';
import globalConfig from '@utiles/officialStore/globalConfig';

export default {
  computed: {
    ...mapState({
      passportToken: state => state.login.passportToken,
      gameId: state => state.gameId
    })
  },
  methods: {
    globalBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN).then(async res => {
        // 2024.08.08 邓智轩：需要检查的游戏，且IP为日本时，跳转pns站点
        let winLang = '';
        if (window.navigator) {
          winLang =
            globalConfig.getLanguages() ||
            window.navigator.language ||
            window.navigator.browserLanguage ||
            window.navigator.systemLanguage;
        } else {
          winLang = globalConfig.getLanguages();
        }
        if (NEED_TO_JUMP_PNS_GAMEID.includes(+this.gameId)) {
          if (winLang === 'ja-JP') {
            jumpPnsWithToken(this.passportToken);
            return;
          }
          this.$store.dispatch(CHECK_IP_LOCATION).then(ipRes => {
            if (ipRes.ISO_TWO_CODE == 'JP') {
              jumpPnsWithToken(this.passportToken);
            }
          });
        }
        if (!res) {
          return;
        }
        this.$store.dispatch(GET_LASTED_STORE_ROLE);
        const canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: this.$store.state.gameId
        });
        if (canContinue === false) {
          globalConfig.jumpErrorPage();
          return;
        }
      });
    },
    jpBeforeCreate() {
      this.$store.dispatch(JUDGE_IS_LOGIN);
    }
  },
  created() {
    this.$store.getters.isJpPlatform
      ? this.jpBeforeCreate()
      : this.globalBeforeCreate();
  }
};
